<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M2.577 1.305h9.23c.376 0 .776-.01 1.149.012.192.01.302.047.436.183.159.16.205.318.205.538-.002.702-.002 1.404-.002 2.106v4.535l.001 2.176c0 .351.008.725-.01 1.075a.687.687 0 0 1-.197.382c-.258.277-.714.212-1.069.211l-1.18-.003.002-1.54 1.553-.001.005-.402-1.56-.002.002-.7h1.554c.002-.13.001-.263.002-.393h-1.559l.003-.7 1.553-.002c.004-.133.003-.27.004-.403-.517-.006-1.042-.001-1.56-.002l.003-.703 1.553-.002c.005-.13.003-.271.004-.403l-1.559-.001c0-.234 0-.469.002-.703l1.553-.001c.003-.132.003-.267.005-.399-.51-.011-1.048-.004-1.56-.005l.002-.702 1.55-.002c.009-.13.005-.273.005-.405l-1.558-.001.002-.703h1.554c.005-.128.002-.264.002-.393-.514-.008-1.041-.002-1.557-.003 0-.234 0-.47.002-.704l.482-.004c.357.003.714.002 1.071-.004.006-.126.004-.268.005-.395a32.087 32.087 0 0 0-1.56-.002v-.098c.002-.589-.319-.969-.914-.963-.241.002-.492-.001-.734-.001h-1.77c-1.827 0-3.7-.022-5.523.004.051.091.123.208.237.216.44.032 1.01.017 1.447.016h5.765c.23-.001.477-.008.705.006a.58.58 0 0 1 .342.146c.159.151.2.276.206.486.006.247.004.492.004.738v5.46l-.002 2.966.002.845c.003.397.06.86-.355 1.086a.764.764 0 0 1-.386.095c-.544.003-1.089 0-1.633 0H3.429c-.226 0-.763.016-.964-.01a.879.879 0 0 1-.488-.23c-.216-.205-.274-.444-.274-.727-.002-.817 0-1.636 0-2.452V3.179L1.7 2.366c0-.298-.04-.627.19-.857.2-.202.423-.202.686-.204Z"
        />
        <path
            fill="#fff"
            d="m4.41 5.367.918-.002c.23.377.527.804.773 1.184l1.433 2.226c-.019-.403-.007-.896-.007-1.307l.004-2.102c.254.002.508.002.762 0V9.43c0 .134.008.377-.004.505-.035.029-.042.019-.098.02l-.75.002c-.056-.125-.394-.632-.481-.77L5.77 7.346c-.14-.215-.479-.71-.582-.92-.024 1.148-.004 2.377-.005 3.53h-.785L4.4 6.742l-.003-.836c-.001-.143-.007-.405.013-.54Z"
        />
    </svg>
</template>

<script setup lang="ts">
type OneNoteIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<OneNoteIconProps>();
</script>
